<template>
	<Card class="flex cursor-pointer transition-colors w-full ease-in-out border-1
			!shadow-sm hover:shadow-md hover:border-primary dark:hover:border-primary/50 hover:!bg-primary/15" :class="{
				'border-primary !bg-primary/15 dark:border-primary/50': selectedRender,
				'border-gray-200 dark:border-gray-700': !selectedRender
			}" @click="$emit('update:modelValue', !modelValue)" @mouseover="hovering = true" @mouseleave="hovering = false">
		<template #content>
			<p
				:class="{ 'text-gray-700 dark:text-gray-200': selectedRender, 'text-gray-800 group-hover:text-gray-700 dark:text-gray-300 group-hover:dark:text-gray-200': !selectedRender }">
				{{ prize.description }}</p>
		</template>
	</Card>
</template>

<script setup lang="ts">
import type { NewPrizeSuggestion } from '@/types';
import { computed, ref } from "vue";

const props = defineProps<{
	prize: NewPrizeSuggestion;
	modelValue: boolean;
}>();

const hovering = ref(false);

const selectedRender = computed(() => hovering.value || props.modelValue);

defineEmits<{
	(e: 'update:modelValue', value: boolean): void;
}>();

</script>

<style scoped>
:deep(.p-card-body) {
	display: flex;
	flex-direction: column;
	height: 100%;
}

:deep(.p-card-content) {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
}
</style>
